import type { VideoStreamInfo } from '../types';
import { API_BASE_URL, API_ORIGIN } from '../services/api';

/**
 * مبدأیی که تگ &lt;video&gt; باید به آن درخواست بزند — همان منطقِ axios:
 * اگر `REACT_APP_API_URL` نسبی است (`/api`)، پخش از همان origin صفحه می‌رود (نیاز به پراکسی production).
 */
export function getMediaPlaybackOrigin(): string {
  if (typeof window === 'undefined') return API_ORIGIN;
  const relative = API_BASE_URL.startsWith('/') && !API_BASE_URL.startsWith('//');
  if (relative) return window.location.origin;

  let origin = API_ORIGIN;
  try {
    const pageHost = window.location.hostname;
    const api = new URL(origin);
    if (pageHost === '127.0.0.1' && api.hostname === 'localhost') {
      api.hostname = '127.0.0.1';
      origin = api.origin;
    } else if (pageHost === 'localhost' && api.hostname === '127.0.0.1') {
      api.hostname = 'localhost';
      origin = api.origin;
    }
  } catch {
    /* noop */
  }
  return origin;
}

export function buildCourseVideoPlaybackUrl(
  videoId: string,
  streamInfo: Pick<VideoStreamInfo, 'streamUrl'> | null,
  quality: string,
  options?: { streamTest?: boolean },
): string {
  if (options?.streamTest === true) {
    const origin = getMediaPlaybackOrigin();
    const q =
      quality === 'auto'
        ? ''
        : `?quality=${encodeURIComponent(quality)}`;
    return `${origin}/api/videos/${videoId}/stream-test${q}`;
  }

  const origin = getMediaPlaybackOrigin();
  const params = new URLSearchParams();

  let pathname = `/api/videos/${videoId}/stream`;
  if (streamInfo?.streamUrl) {
    try {
      const u = new URL(streamInfo.streamUrl);
      if (u.pathname) pathname = u.pathname;
      const fromServer = new URLSearchParams(u.search);
      fromServer.forEach((v, k) => {
        params.set(k, v);
      });
    } catch {
      /* نادیده — از مسیر پیش‌فرض و توکن محلی استفاده می‌شود */
    }
  }

  const token =
    typeof window !== 'undefined' ? localStorage.getItem('token')?.trim() : '';
  if (token && !params.has('token')) {
    params.set('token', token);
  }

  if (quality !== 'auto') {
    params.set('quality', quality);
  }

  const qs = params.toString();
  return qs ? `${origin}${pathname}?${qs}` : `${origin}${pathname}`;
}

export function playbackUrlHasStreamToken(publicUrl: string): boolean {
  try {
    return Boolean(new URL(publicUrl).searchParams.get('token')?.trim());
  } catch {
    return false;
  }
}
